<template>
  <div class="right-menu__sing-up">
    <div class="right-menu__title">
      <h4>Регистрация</h4>
    </div>
    <input id="person-registration" type="radio" name="registration" checked />
    <input id="entity-registration" type="radio" name="registration" />
    <div class="right-menu__registration-menu">
      <label for="person-registration" @click="() => setTypeUser('person')"
        >Физическое лицо</label
      >
      <label for="entity-registration" @click="() => setTypeUser('company')"
        >Юридическое лицо</label
      >
    </div>
    <div class="right-menu__registration-forms">
      <div class="t-form">
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: personErrors.username }">
            <input
              type="text"
              id="sing-up-name"
              v-model="person.username"
              @click="() => clearError('person', 'username')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: person.username }"
              for="sing-up-name"
            >
              ФИО
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              personErrors.usernameText
            }}</span>
          </div>
        </div>
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: personErrors.phone }">
            <input
              type="text"
              id="sing-up-phone"
              @input="phoneFormat"
              :value="person.phone"
              maxlength="17"
              @click="() => clearError('person', 'phone')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: person.phone }"
              for="sing-up-phone"
            >
              Номер телефона
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              personErrors.phoneText
            }}</span>
          </div>
        </div>
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: personErrors.password }">
            <input
              type="password"
              id="sing-up-password"
              v-model="person.password"
              @click="() => clearError('person', 'password')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: person.password }"
              for="sing-up-password"
            >
              Пароль
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              personErrors.passwordText
            }}</span>
          </div>
        </div>
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: personErrors.password }">
            <input
              type="password"
              id="sing-up-password_repeat"
              v-model="password_repeat"
              @click="() => clearError('person', 'password')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: password_repeat }"
              for="sing-up-password_repeat"
            >
              Повторите пароль
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              personErrors.passwordText
            }}</span>
          </div>
        </div>
      </div>
      <div class="t-form">
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: companyErrors.username }">
            <input
              type="text"
              id="sing-up-company-name"
              v-model="company.username"
              @click="() => clearError('company', 'username')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: company.username }"
              for="sing-up-company-name"
            >
              Название компании
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              companyErrors.usernameText
            }}</span>
          </div>
        </div>
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: companyErrors.phone }">
            <input
              type="text"
              id="sing-up-company-phone"
              @input="phoneFormat"
              :value="company.phone"
              maxlength="17"
              @click="() => clearError('company', 'phone')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: company.phone }"
              for="sing-up-company-phone"
            >
              Номер телефона
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              companyErrors.phoneText
            }}</span>
          </div>
        </div>
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: companyErrors.license }">
            <input
              type="text"
              id="sing-up-company-license"
              v-model="company.license"
              @click="() => clearError('company', 'license')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: company.license }"
              for="sing-up-company-license"
            >
              ИНН или ОГРН
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              companyErrors.licenseText
            }}</span>
          </div>
        </div>
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: companyErrors.password }">
            <input
              type="password"
              id="sing-up-company-password"
              v-model="company.password"
              @click="() => clearError('company', 'password')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: company.password }"
              for="sing-up-company-password"
            >
              Пароль
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              companyErrors.passwordText
            }}</span>
          </div>
        </div>
        <div class="t-form__row">
          <div class="t-form__input" :class="{ error: companyErrors.password }">
            <input
              type="password"
              id="sing-up-company-password-repeat"
              v-model="password_repeat"
              @click="() => clearError('company', 'password')"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: password_repeat }"
              for="sing-up-company-password-repeat"
            >
              Повторите пароль
              <span>*</span>
            </label>
            <span class="t-form__input-error">{{
              companyErrors.passwordText
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <p class="right-menu__text">
      Нажимая кнопку зарегистрироваться вы даете согласие на обработку
      персональных данных
    </p>
    <t-button type="small blue uppercase" :callback="submit"
      >Зарегистрироваться</t-button
    >
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  components: {
    't-button': Button,
  },
  data: function() {
    return {
      type: 'person',
      person: {
        username: '',
        phone: '',
        password: '',
      },
      company: {
        username: '',
        phone: '',
        license: '',
        password: '',
      },
      password_repeat: '',

      personErrors: {
        username: false,
        usernameText: '',
        password: false,
        passwordText: '',
        phone: false,
        phonetext: '',
      },

      companyErrors: {
        username: false,
        usernameText: '',
        phonetext: '',
        passwordText: '',
        licenseText: '',
        phone: false,
        license: false,
        password: false,
      },

      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('api', ['registration', 'sendCode']),
  },
  methods: {
    ...mapActions('api', ['fetchRequest']),
    ...mapMutations('params', [
      'toogleCodeConfirm',
      'toogleSingup',
      'setSignUpInfo',
      'setConfirmCodeType',
      'setToken',
      'setRecoveryPasswordPhone',
    ]),

    phoneFormat: function({ target }) {
      this[this.type].phone = setPhoneFormat(target.value);
    },
    createPhone: function(value) {
      return resetPhoneFormat(value).slice(1);
    },
    setTypeUser: function(type) {
      this.type = type;
      this[type].password = '';
      this.password_repeat = '';
    },
    validation: function() {
      let error = false;

      Object.keys(this[this.type]).forEach((item) => {
        if (!this[this.type][item].trim()) {
          this.setErrors(item, 'empty');
          error = true;
        }
      });

      if (this[this.type].password !== this.password_repeat) {
        this.setErrors('password', 'mismatchPassword');
        error = true;
      }

      return error;
    },
    setErrors: function(id, error) {
      this[this.type + 'Errors'][id] = true;
      this[this.type + 'Errors'][id + 'Text'] = this.errorsText[error];
    },

    setErrorsQuery: function(id, errorText) {
      this[this.type + 'Errors'][id] = true;
      this[this.type + 'Errors'][id + 'Text'] = errorText;
    },

    clearError: function(type, id) {
      this[type + 'Errors'][id] = false;
    },
    submit: function() {
      if (this.validation()) return;

      this.fetchRequest({
        url: this.registration,
        form: this.form({
          ...this[this.type],
          phone: this.createPhone(this[this.type].phone),
          type: this.type,
        }),
        success: (validateData) => {
          console.log('success validate', validateData);

          if (validateData.body.success) {
            this.fetchRequest({
              url: this.sendCode,
              form: this.form({
                phone: this.createPhone(this[this.type].phone),
              }),
              success: (codeConfirmData) => {
                console.log('success send code', codeConfirmData);
                if (codeConfirmData.body.token) {
                  this.setToken(codeConfirmData.body.token);
                  this.setConfirmCodeType('REGISTRATION');
                  this.setRecoveryPasswordPhone(
                    this.createPhone(this[this.type].phone)
                  );
                  this.setSignUpInfo({
                    ...this[this.type],
                    phone: this.createPhone(this[this.type].phone),
                    type: this.type,
                  });
                  this.toogleSingup();
                  this.toogleCodeConfirm();
                }
              },
              error: (e) => {
                console.log('send code error', e);
              },
            });
          } else {
            Object.keys(validateData.body.error).forEach((item) => {
              this.setErrorsQuery(item, validateData.body.error[item][0]);
            });
          }
        },
        error: (e) => {
          console.log('validate error');
        },
      });
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/singup.vue